import { withStyles } from '@material-ui/core/styles';
import { ToggleButton } from '@material-ui/lab';

export const NormalStyledToggleButton = withStyles({
  root: {
    backgroundColor: '#F3F3F3',
    color: '#DBD8DC',
    minWidth: '21px',
    width: '21px',
    height: '21px',
    fontSize: 18,
    '&.Mui-selected': {
      color: '#9C27B0',
      backgroundColor: '#E1BEE7AB',
      '&:hover': {
        backgroundColor: '#E1BEE7AB',
      },
      '&.Mui-disabled': {
        color: '#9C27B080',
        backgroundColor: '#E7DBE9',
        fontStyle: 'italic',
      },
    },
    '&.Mui-disabled': {
      color: '#DBD8DC',
      backgroundColor: '#EEEEEEAB',
      fontStyle: 'italic',
    },
  },
})(ToggleButton);
export const SplitStyledToggleButton = withStyles({
  root: {
    color: 'currentColor',
    minWidth: '30px',
    width: '30px',
    height: '30px',
    fontSize: 18,
    fontWeight: 350,
    '&.Mui-selected': {
      color: '#9C27B0',
      backgroundColor: '#EBD3EF',
      '&.Mui-disabled': {
        color: '#9C27B080',
        backgroundColor: '#EBD3EF',
        fontStyle: 'italic',
      },
    },
    '&.Mui-disabled': {
      color: '#DBD8DC',
      fontStyle: 'italic',
    },
  },
})(ToggleButton);

export const NormalStyledDarkToggleButton = withStyles({
  root: {
    backgroundColor: '#00000040',
    borderColor: '#7D7D7D',
    color: '#FFFFFF',
    minWidth: '21px',
    width: '21px',
    height: '21px',
    fontSize: 18,
    '&.Mui-selected': {
      color: '#9C27B0',
      backgroundColor: '#EBD3EF',
      '&:hover': {
        backgroundColor: '#EBD3EF',
      },
      '&.Mui-disabled': {
        color: '#9C27B0',
        backgroundColor: '#B3A3B6',
        fontStyle: 'italic',
      },
    },
    '&.Mui-disabled': {
      color: '#7D7D7D',
      backgroundColor: '#00000040',
      fontStyle: 'italic',
    },
  },
})(ToggleButton);
